import { __decorate } from "tslib";
import { Component, Watch, Vue } from 'vue-property-decorator';
import CardLayout from '@/layouts/CardLayout.vue';
import Background from '@/components/Background.vue';
import Next from '@/components/Next.vue';
import CounterButton from '@/components/CounterButton.vue';
import SpinnerHolder from '@/components/SpinnerHolder.vue';
import CommonHeader from '@/components/CommonHeader.vue';
import BeeCheckbox from '@/components/BeeCheckbox.vue';
import MiniCart from '@/components/MiniCart.vue';
import Modal from '@/components/Modal.vue';
import CommentsButton from '@/components/CommentsButton.vue';
import LikeButton from '@/components/LikeButton.vue';
import AjaxButton from '@/components/AjaxButton.vue';
import Review from '../models/Review';
import MenuService from '../services/MenuService';
let Reviews = class Reviews extends Vue {
    constructor() {
        super(...arguments);
        this.product = null;
        this.selected = 'all';
        this.userCommented = false;
        this.user = this.$store.state.user;
        this.reviews = [];
        this.barColor = this.$store.getters.colors.backgroundColor;
        this.loading = false;
        this.modalForm = false;
        this.formData = {
            name: '',
            text: '',
            positive: true
        };
        this.formErrors = { name: false, text: false, valid: false };
        this.ajaxError = false;
    }
    async onSelectedChanged(newSelection) {
        if (this.product) {
            this.loading = true;
            this.reviews = await MenuService.getReviewsOfProduct(this.product.id, newSelection);
            this.reviews = this.reviews.sort((c, n) => c.createdAt.getTime() - n.createdAt.getTime());
            this.loading = false;
        }
    }
    showForm() {
        const text = this.formData.text.trimStart();
        if (this.userCommented === false && text.length > 1) {
            this.modalForm = true;
        }
    }
    async sendForm() {
        if (!this.validForm())
            return;
        if (!this.product)
            return;
        if (!this.user)
            return;
        this.loading = true;
        const newReview = new Review(this.user.id);
        newReview.content = this.formData.text;
        newReview.language = this.$store.state.language;
        newReview.name = this.formData.name;
        newReview.createdAt = new Date();
        newReview.positive = this.formData.positive;
        let token = '';
        if (process.env.NODE_ENV == 'production') {
            await this.$recaptchaLoaded();
            token = await this.$recaptcha('sendOrder');
        }
        const result = await MenuService.sendReview(this.product.id, newReview, token);
        if (result) {
            this.userCommented = true;
        }
        else {
            this.ajaxError = true;
        }
        this.loading = false;
    }
    hideForm() {
        this.modalForm = false;
    }
    validForm() {
        this.formErrors = { name: false, text: false, valid: false };
        if (!this.formData.name) {
            this.formErrors.name = true;
        }
        for (const error of Object.values(this.formErrors)) {
            if (error == true) {
                return false;
            }
        }
        return true;
    }
    getProduct(productId) {
        const products = this.$store.getters.products;
        const product = products.find(p => p.id == productId);
        return product || null;
    }
    formatDate(d) {
        //return `${d.getDay()}/${d.getMonth()}/${d.getFullYear()} : ${d.getHours()}:${d.getMinutes()}`
        return d.toLocaleDateString();
    }
    goBack() {
        history.back();
    }
    get imageCSS() {
        if (this.product && this.product.photosURL)
            return `background-image: url('${this.product.photosURL[0]}'`;
        return '';
    }
    get borderColorCSS() {
        return `border-bottom-color: ${this.barColor};`;
    }
    async created() {
        this.product = this.getProduct(this.$route.params.productId);
        if (this.product && this.user) {
            this.userCommented = await MenuService.userCommentedProduct(this.product.id, this.user.id);
        }
    }
    async mounted() {
        if (this.product) {
            this.loading = true;
            this.reviews = await MenuService.getReviewsOfProduct(this.product.id, this.selected);
            this.reviews = this.reviews.sort((c, n) => c.createdAt.getTime() - n.createdAt.getTime());
            this.loading = false;
        }
    }
};
__decorate([
    Watch('selected')
], Reviews.prototype, "onSelectedChanged", null);
Reviews = __decorate([
    Component({
        components: {
            Background,
            CardLayout,
            CommonHeader,
            Next,
            CounterButton,
            SpinnerHolder,
            BeeCheckbox,
            Modal,
            MiniCart,
            CommentsButton,
            LikeButton,
            AjaxButton
        }
    })
], Reviews);
export default Reviews;
